// routes/luxotticaAuthRoutes.js
import IconicRegisterPage from '@/pages/iconic-register';
import IconicLoginPage from '@/pages/iconic-login';
import IconicRecoveryPage from '@/pages/iconic-recovery';
import IconicUnauthorizedPage from '@/pages/iconic-unathorized';
import { buildPath } from '../utils/routeBuilder';

const iconicAuthRoutes = [
  { 
    path: buildPath('/iconic/register'), 
    element: <IconicRegisterPage />
  },
  { 
    path: buildPath('/iconic/login'), 
    element: <IconicLoginPage />
  },
  { 
    path: buildPath('/iconic/forgot-password'), 
    element: <IconicRecoveryPage />
  },
  { 
    path: buildPath('/iconic/unauthorized'), 
    element: <IconicUnauthorizedPage />
  }
];

export default iconicAuthRoutes;